var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: {
        title: "客户经理项目人角色",
        "mask-closable": false,
        width: "800",
      },
      model: {
        value: _vm.showRoleEditModal,
        callback: function ($$v) {
          _vm.showRoleEditModal = $$v
        },
        expression: "showRoleEditModal",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "table-container",
          staticStyle: {
            "max-height": "350px",
            "overflow-y": "auto",
            "margin-bottom": "20px",
          },
        },
        [
          _c("stand-pagination-table", {
            attrs: {
              columns: _vm.mainTable.columns,
              data: _vm.mainTable.data,
              loading: _vm.mainTable.loading,
              "table-search": _vm.mainTable.tableSearch,
              "table-load-event": _vm.getRole,
              totalSummaryFieldDatas: _vm.mainTable.sumData,
              autoHeight: true,
              showPage: true,
            },
          }),
        ],
        1
      ),
      _c("Divider", [_vm._v("编辑区域")]),
      _c(
        "Form",
        {
          ref: "columnForm",
          attrs: { model: _vm.form, rules: _vm.formRules, "label-width": 80 },
        },
        [
          _c(
            "FormItem",
            { attrs: { label: "角色名称", prop: "name" } },
            [
              _c("Input", {
                attrs: { placeholder: "请输入角色名称" },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _c(
            "FormItem",
            { attrs: { label: "状态", prop: "recordStatus" } },
            [
              _c(
                "RadioGroup",
                {
                  attrs: { type: "button" },
                  model: {
                    value: _vm.form.recordStatus,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "recordStatus", $$v)
                    },
                    expression: "form.recordStatus",
                  },
                },
                _vm._l(_vm.statusOptions, function (item) {
                  return _c(
                    "Radio",
                    { key: item.val, attrs: { label: item.val } },
                    [_vm._v(_vm._s(item.label))]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("Button", { on: { click: _vm.handleCancel } }, [_vm._v("取消")]),
          _c(
            "Button",
            {
              attrs: { type: "primary", loading: _vm.isSaving },
              on: { click: _vm.handleSave },
            },
            [_vm._v("\n            保存\n        ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }